/**
 * Utility function to format a date string or Date object into a localized Dutch date format
 * @param date The date to format, either as a string or a Date object
 * @param showYear Optional boolean to include the year in the formatted output (default: true)
 * @returns A formatted date string in Dutch locale
 */
export const formatDate = (date: string | Date, showYear = true) => {
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    ...(showYear && { year: 'numeric' }),
  }
  return new Date(date).toLocaleDateString('nl-NL', options)
}

export const formatDateEventDetail = (date: string | Date) => {
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
  }
  return new Intl.DateTimeFormat('nl-NL', options)
    .formatToParts(new Date(date))
    .map((part) => (part.type === 'weekday' ? part.value.charAt(0).toUpperCase() + part.value.slice(1) : part.value))
    .join('')
}

export const formatDateCourseDetail = (date: string | Date) => {
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }
  return new Date(date).toLocaleDateString('nl-NL', options)
}

export const formatTimeCourseDetail = (date: string | Date) => {
  const options: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
  }
  return new Date(date).toLocaleTimeString('nl-NL', options)
}

export const formatDateCourseOverviewItem = (date: string | Date) => {
  const options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }
  return new Date(date).toLocaleDateString('nl-NL', options)
}

export const formatDateNumeric = (date: string | Date) => {
  const parsed = new Date(date)
  const month = String(parsed.getMonth() + 1).padStart(2, '0')
  const day = String(parsed.getDate()).padStart(2, '0')
  return `${day}.${month}`
}

export const formatTimeCourseOverviewItem = (startDate: string | Date, endDate?: string | Date) => {
  const options: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
  }
  return `${new Date(startDate).toLocaleTimeString('nl-NL', options)}${endDate ? ` - ${new Date(endDate).toLocaleTimeString('nl-NL', options)}` : ''}`
}
